import { render, staticRenderFns } from "./RelatedItemsTab.vue?vue&type=template&id=7ea241a3"
import script from "./RelatedItemsTab.ts?vue&type=script&lang=ts&external"
export * from "./RelatedItemsTab.ts?vue&type=script&lang=ts&external"
import style0 from "./RelatedItemsTab.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports